module.exports = __webpack_public_path__ + "static/media/peerFivesLogo.5311cb61.svg";